import {Map} from 'immutable';
import {REDUCE_GET_NEW_MESSAGE, REDUCE_UPDATE_NEW_MESSAGE} from '@store/types';

const initState = Map({
    newMessage: null
});

export default function message(state = initState, {type, data}: any) {
    switch (type) {
    case REDUCE_GET_NEW_MESSAGE:
        return state.set('newMessage', data);
    case REDUCE_UPDATE_NEW_MESSAGE:
        //@ts-ignore
        return state.updateIn(['newMessage', 'newMessageNum'], (val: number) => val ? val - 1 : val);
    default:
        return state;
    }
}